// extracted by mini-css-extract-plugin
export var collapsibleStepsList = "collapsible-steps-list_ZZnHgNqx44xSjHnYgT0O";
export var docLink = "doc-link_lTosDiqLGGOXC0IAZRNi";
export var downloadCard = "download-card_n0UpshA3uley98H13d9K";
export var downloadCardDescription = "download-card-description_bUbkMzeq1GLhHEAyLOQ9";
export var downloadRow = "download-row_Eq7Acw0apmTmNO_UN1ed";
export var downloadSpMetadataContainer = "download-sp-metadata-container_tLcIA0wqPW2TtTz1MFLw";
export var expandButton = "expand-button_cWZfWUwZsSrSvMsp5dB9";
export var instructionsList = "instructions-list_l5B0ikMSUHtbYtyQRZhh";
export var instructionsSection = "instructions-section_L1wowDjPoP9IRU29HSan";
export var manualCard = "manual-card_Z822YS0zADmWWIkuUZJQ";
export var manualDescription = "manual-description_dLqX60Pbbd1816BH0muk";